import React from "react";
import { successAction, errorAction, requestAction } from "@authzsvc/api-lib";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";

export const RequestState = {
  NOT_STARTED: "not_started",
  STARTED: "started",
  SUCCESS: "success",
  ERROR: "error",
};

export function makeRequestReducer(apiCall) {
  const onStart = requestAction(apiCall);
  const onSuccess = successAction(apiCall);
  const onError = errorAction(apiCall);
  const initialState = { state: RequestState.NOT_STARTED, error: null };
  return (state = initialState, action) => {
    switch (action.type) {
      case onStart:
        return { ...state, state: RequestState.STARTED, error: null };
      case onSuccess:
        return { ...state, state: RequestState.SUCCESS, error: null };
      case onError:
        return { ...state, state: RequestState.ERROR, error: action.error };
      default:
        return state;
    }
  };
}

export function showErrorNotification(title, message, duration = 4.5) {
  notification["error"]({
    message: title ?? "Something went wrong",
    description: message ?? "We are sorry! An error has occurred.",
    duration,
  });
}

export const withRouterCompat = (Component) => {
  return function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  };
};
